import api from "./apiMasterData.js";

export default {
  GetCompanies() {
    return api.get("Companies/Read");
  }
};
